import liveIvr from './liveIvr';
import localDemo from './localDemo';
import distributorCategoryPricing from './distributorCategoryPricing';
import feedback from './feedback';
import distributor from './distributor';
import distributorCustomerEditing from './distributorCustomerEditing';
import distributorOverview from './distributorOverview';
import distributorPayments from './distributorPayments';
import distributorOperations from './distributorOperations';
import distributorReports from './distributorReports';
import distributorAccounting from './distributorAccounting';
import distributorMerchantFunding from './distributorMerchantFunding';
import distributorCash from './distributorCash';
import distributorCashFunding from './distributorCashFunding';
/**
 * SPANISH DICTIONARY - assembled from one fragment per area of the app.
 *
 * Every key is the exact English string the UI renders (placeholders as `{name}`); every value is
 * its Spanish. A fragment is a plain object, so two fragments may carry the same key as long as
 * they agree - es.test.js fails the build on a disagreement, an empty value, or a placeholder that
 * the Spanish uses but the English does not.
 */
import clinicOrderForms from './clinicOrderForms';
import helpCenter from './helpCenter';
import resourceCenter from './resourceCenter';
import shell from './shell';
import statements from './statements';
import ivr from './ivr';
import orders from './orders';
import billing from './billing';
import records from './records';
import system from './system';
import people from './people';
import hub from './hub';
import hubDialog from './hubDialog';
import hubOrdering from './hubOrdering';
import legal from './legal';
import safeErrors from './safeErrors';
import quickBooks from './quickBooks';

export const FRAGMENTS = {
  localDemo,
  liveIvr,
  distributorCategoryPricing,
  distributorCashFunding,
  distributor,
  distributorCustomerEditing,
  distributorOverview,
  distributorPayments,
  distributorOperations,
  distributorReports,
  distributorAccounting,
  distributorMerchantFunding,
  distributorCash,
  feedback,
  resourceCenter,
  helpCenter,
  clinicOrderForms,
  shell,
  statements,
  ivr,
  orders,
  billing,
  records,
  system,
  people,
  hub,
  hubDialog,
  hubOrdering,
  legal,
  safeErrors,
  quickBooks,
};

const es = Object.assign({}, ...Object.values(FRAGMENTS));

export default es;
